import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../../_shared/authentication.service';

@Component({
	selector: 'pm-logout',
	template: `<p>Logging out!</p>`,
})
export class LogoutComponent {

	constructor(
		private authenticationService: AuthenticationService,
		private _router: Router,
	) {
		setTimeout(() => {
			authenticationService.logout();
			_router.navigate(['/admin/login']);
		}, 100);
	}

}
